import { APP_CDT_SCHEME } from './constants'

export * from './constants'

export function buildAppCdtDeepLink(linkId: string) {
  return `${APP_CDT_SCHEME}?linkId=${encodeURIComponent(linkId)}`
}

export function isMobileDevice() {
  if (typeof navigator === 'undefined') {
    return false
  }

  const userAgent = navigator.userAgent || ''

  if (/Android|iPhone|iPod/i.test(userAgent)) {
    return true
  }

  const isIpad =
    /iPad/i.test(userAgent) ||
    (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1)

  return isIpad
}
